module.exports = __webpack_public_path__ + "img/hero_en.dbbd65c.jpg";